import { EU_COUNTRY_CODES } from '@packages/domain/constants/geolocation';

export const isEUMemberAccess = state => {
  const {
    geolocation: { countryCode },
  } = state;

  return EU_COUNTRY_CODES.includes(countryCode);
};

export const getCountryCode = state => {
  const { geolocation: { countryCode = null } = {} } = state;

  return countryCode;
};
